module.exports = __webpack_public_path__ + "img/5.92b2c209.png";